'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat from "./presto.-Fetcher$-Unified-Error-Format.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$UnifiedErrorFormat$() {
}
export { $c_Lpresto_Fetcher$UnifiedErrorFormat$ as $c_Lpresto_Fetcher$UnifiedErrorFormat$ };
$p = $c_Lpresto_Fetcher$UnifiedErrorFormat$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$UnifiedErrorFormat$;
/** @constructor */
function $h_Lpresto_Fetcher$UnifiedErrorFormat$() {
}
export { $h_Lpresto_Fetcher$UnifiedErrorFormat$ as $h_Lpresto_Fetcher$UnifiedErrorFormat$ };
$h_Lpresto_Fetcher$UnifiedErrorFormat$.prototype = $p;
$p.l = (function() {
  return "UnifiedErrorFormat";
});
$p.cG0 = (function(x$0) {
  return new $j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat.$c_Lpresto_Fetcher$UnifiedErrorFormat(x$0.j(0), x$0.j(1), (x$0.j(2) | 0), x$0.j(3), x$0.j(4));
});
var $d_Lpresto_Fetcher$UnifiedErrorFormat$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$UnifiedErrorFormat$, "presto.Fetcher$UnifiedErrorFormat$", ({
  ID: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_Fetcher$UnifiedErrorFormat$ as $d_Lpresto_Fetcher$UnifiedErrorFormat$ };
var $n_Lpresto_Fetcher$UnifiedErrorFormat$;
function $m_Lpresto_Fetcher$UnifiedErrorFormat$() {
  if ((!$n_Lpresto_Fetcher$UnifiedErrorFormat$)) {
    $n_Lpresto_Fetcher$UnifiedErrorFormat$ = new $c_Lpresto_Fetcher$UnifiedErrorFormat$();
  }
  return $n_Lpresto_Fetcher$UnifiedErrorFormat$;
}
export { $m_Lpresto_Fetcher$UnifiedErrorFormat$ as $m_Lpresto_Fetcher$UnifiedErrorFormat$ };
//# sourceMappingURL=presto.-Fetcher$-Unified-Error-Format$.js.map
